<section class="statistical-highlights-container">
  <div class="statistical-highlights-content">
    <fl-statistic-data-card
      *ngFor="let statisticDataCard of statisticDataCards; let last = last"
      [card]="statisticDataCard"
      [last]="last"
    ></fl-statistic-data-card>
  </div>
</section>
